// extracted by mini-css-extract-plugin
export default {"container":"LiveVideo_container__mUize","pagination":"LiveVideo_pagination__lR4mj"};